import React, { Component } from 'react';
import { PulseLoader } from 'react-spinners';
import queryString from 'query-string';
import { document, meta } from './api';

import './LegalPage.scss';
import Header from './Header';

const defaultSelection = {
  updated: '',
  content: ''
};

class LegalPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      background: '',
      datehidden: false,
      selected: defaultSelection,
      docs: []
    };
  }

  componentDidMount() {
    const leadingZero = (num) => (num < 10 ? `0${num}` : num);
    const now = new Date();
    const nowYYYYMMDD = `${now.getFullYear()}-${leadingZero(now.getMonth() + 1)}-${leadingZero(now.getDate())}`;
    const { current } = queryString.parse(this.props.location.search);
    meta(this.props.location.pathname.replace(/^\/+|\/+$/g, '').replace(/\//g, '_'))
      .then((meta) => ({
        title: meta.title,
        categoryId: meta.uid,
        datehidden: meta.datehidden,
        background: meta.background.url
      }))
      .then(({ title, categoryId, datehidden, background }) => {
        document()
          .then((payload) => {
            return payload;
          })
          .then(({ entries }) =>
            entries
              .filter((entry) => entry.legal_category[0].uid === categoryId)
              .map((entry) => ({
                docId: entry.uid,
                updated: entry.affected_date || entry.updated_date,
                content: entry.body
              }))
              .sort((a, b) => -1 * a.updated.localeCompare(b.updated))
          )
          .then((docs) => {
            const selected =
              (docs.length === 1 && docs) ||
              (current && docs.filter((item) => item.docId === current)) ||
              docs.filter((item) => item.updated.localeCompare(nowYYYYMMDD) <= 0);
            this.setState({
              title: title,
              datehidden: datehidden,
              background: background,
              selected: selected && selected.length ? selected[0] : defaultSelection,
              docs: docs
            });
          });
      });
  }

  onChangeDoc(e) {
    const selectedDate = e.target.value;
    const selected = this.state.docs.filter((doc) => doc.updated === selectedDate);
    this.setState({ selected: selected && selected[0] });
  }

  _buildToc(content) {
    const h1Entries = this.state.selected.content.match(/(?:<h1>[^<]+<\/h1>)/gm);
    return h1Entries && h1Entries.length ? h1Entries.map((html) => html.substring(4, html.length - 5)) : [];
  }

  render() {
    const {
      title,
      datehidden,
      docs,
      background,
      selected: { updated, content }
    } = this.state;

    const markup = { __html: `${content}` };
    const backgroundStyle = {
      backgroundImage: `url(${background})`
    };

    const tocEntries = this._buildToc(content);
    return (
      <div className={'legal-page'}>
        <Header title={title} style={backgroundStyle} />
        <div className={'content'}>
          <div className={'toc'}>
            <div className={'toc-title'}>목차</div>
            {!datehidden && (
              <div className={'selector'}>
                <select className={'list'} value={updated} onChange={this.onChangeDoc.bind(this)}>
                  {docs.map((doc, index) => (
                    <option key={index} value={doc.updated}>
                      {doc.updated}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <div className={'toc-entries'}>
            {tocEntries.map((entry, index) => (
              <div key={index} className={'entry'}>
                <a href={`#${index + 1}`}> {entry} </a>
              </div>
            ))}
          </div>
          {content ? (
            <div className={'document'} dangerouslySetInnerHTML={markup} />
          ) : (
            <div className={'loading'}>
              <PulseLoader color={'#55555599'} loading={true} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default LegalPage;
